module.exports = __webpack_public_path__ + "img/index5.470b9e25.png";